/**
 * Product Selector Quote Form Config
 * @author Rhys Lloyd
 */

export const MODULE_PREFIX = 'ps-qf';
export const MODULE_WORD_SELECTOR = `${MODULE_PREFIX}-word-selector`;
export const WORD_SELECTOR_SELECTOR = `[data-${MODULE_WORD_SELECTOR}]`;
export const WORD_SELECTOR_CONTROL_SELECTOR = `[data-${MODULE_WORD_SELECTOR}-control]`;
export const WORD_SELECTOR_TEMPLATE_SELECTOR = `[data-${MODULE_WORD_SELECTOR}-template]`;



// WEBPACK FOOTER //
// ./project/client/src/core/modules/ps-quote-form/config.js